import React, { useState, useEffect } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { withRouter } from "react-router-dom";

import { StorageHandler } from "C4";

import { storageKeys } from "settings";

const HeaderBack = ({ history, location }) => {
  const [logo, setLogo] = useState(null);
  const { pathname } = location;

  const getAppInfo = async () => {
    const appInfo = await StorageHandler.load(storageKeys.appInfo);
    if (appInfo) {
      setLogo(appInfo.logo_white);
    }
  };

  useEffect(() => {
    getAppInfo();
  }, []);

  let path = "/main";
  if (pathname && pathname.match(/\/(.*?)\/(.*?)\//g)) {
    const [returnPath] = pathname.match(/\/(.*?)\/(.*?)\//g);
    path = returnPath.substring(0, returnPath.length - 1);
  }
  return (
    <div className="header header-back">
      <nav>
        <ul>
          <button onClick={() => history.push(path)}>
            <FontAwesomeIcon icon={["fas", "chevron-left"]} /> Back
          </button>
          {logo && <img src={`${logo}`} className="logo" alt="logo" />}
        </ul>
      </nav>
    </div>
  );
};

export default withRouter(HeaderBack);
